import React from 'react'
import { ErrorLayout } from './components/ErrorLayout'

export function UnavailablePage() {
    return (
        <ErrorLayout>
            <h1 className={'pkt-txt-22 mb-size-20'}>Flere digitale tjenester for barnehage er stengt til og med 11. november</h1>
            <p>Vi bytter til nytt barnehagesystem, og flere tjenester er derfor utilgjengelige:</p>
            <ul style={{ listStyle: 'none', padding: 0 }}>
                <li>Søknad om plass, permisjon og oppsigelse er stengt til og med 11. november.</li>
                <li>Søknad om redusert pris er stengt til og med 11. november.</li>
                <li>Tilbud om plass sendes ikke ut før etter 11. november.</li>
            </ul>
            <p>Søknader som allerede er sendt inn, blir overført til det nye systemet.</p>
            <p><a href={"https://www.oslo.kommune.no/barnehage/"}>Gå til startsiden for barnehage</a></p>
        </ErrorLayout>
    );
}
